import { createFileRoute } from '@tanstack/react-router';
import { UserProfileContent } from './p.$id';

export const Route = createFileRoute('/p/$id/folder/$folderId/$slug/')({
  component: PublicFolderIndexRoute,
});

function PublicFolderIndexRoute() {
  const { id: userId, folderId, slug } = Route.useParams();
  return (
    <UserProfileContent userId={userId} page={1} folderId={folderId} folderSlug={slug} />
  );
}
